import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import * as currency from '@shopify/theme-currency';

class CartBundleItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rootUrl: window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '',
      minQuantity: 0,
      maxQuantity: 0,
    };
  }

  handleChange(keys, qty, max = 0) {
    if (max > 0 && qty > max) {
      window.console.log(`Max ${max} items in cart.`);
      return;
    }

    const updateCart = this.props.updateCart;
    const data = {};
    keys.forEach(key => (data[key] = qty));
    axios({
      method: 'POST',
      url: `${this.state.rootUrl}/cart/update.js`,
      data: {updates: data},
      responseType: 'JSON',
    })
      .then(response => {
        updateCart(response.data);
      })
      .catch(err => window.console.log(err));
  }

  async componentDidUpdate(prevProps) {
    if (this.props.minMax !== prevProps.minMax) {
      const bundleItemsIds = this.props.cartItems
        .filter(cartItem => cartItem.properties && cartItem.properties._bundle == this.props.item.properties._bundle)
        .map(bundleItem => bundleItem.product_id);

      const bundleMinMaxQuantities = this.props.minMax.filter(minMaxItem => bundleItemsIds.includes(minMaxItem.id));

      const minMaxQuantity = bundleMinMaxQuantities.reduce(
        (prevMinMaxItem, nextMinMaxItem) => {
          const minMax = {...prevMinMaxItem};
          if (nextMinMaxItem.min > prevMinMaxItem.min) {
            minMax.min = nextMinMaxItem.min;
          }
          if (nextMinMaxItem.max > 0 && (prevMinMaxItem.max == 0 || nextMinMaxItem.max < prevMinMaxItem.max)) {
            minMax.max = nextMinMaxItem.max;
          }
          return minMax;
        },
        {min: 0, max: 0}
      );

      if (minMaxQuantity) {
        this.setState({
          minQuantity: minMaxQuantity.min,
          maxQuantity: minMaxQuantity.max,
        });
      }
    }
  }

  render() {
    const {item, cartItems} = this.props;
    const itemPrice = cartItems.reduce((total, cartItem) => {
      if (cartItem.properties && cartItem.properties._bundle == item.properties._bundle) {
        return total + cartItem.final_line_price;
      }
      return total;
    }, 0);
    const itemKeys = cartItems
      .filter(cartItem => cartItem.properties && cartItem.properties._bundle == item.properties._bundle)
      .map(cartItem => cartItem.key);
    const isPreorder = cartItems.some(
      cartItem =>
        cartItem.properties && cartItem.properties._bundle == item.properties._bundle && cartItem.properties.Preorder
    );
    const preorderItemWithDate =
      isPreorder &&
      cartItems.find(
        cartItem =>
          cartItem.properties &&
          cartItem.properties._bundle == item.properties._bundle &&
          cartItem.properties.Preorder &&
          cartItem.properties.Preorder !== 'true'
      );
    const preorderLabel = preorderItemWithDate
      ? window.theme.strings.preorderFor.replace('{{ date }}', preorderItemWithDate.properties.Preorder)
      : window.theme.strings.preorder;

    return (
      <li className="cart-item">
        <div className="cart-item__body">
          <div className="cart-item__image">
            <a href={`/products/${item.properties._bundle_handle}`}>
              <img loading="lazy" src={item.properties._bundle_image} alt={item.title} />
            </a>
          </div>
          <div className="cart-item__content">
            <p className="cart-item__title">{item.properties._bundle_title}</p>
            <p className="cart-item__description"></p>
            {isPreorder && <p className="cart-item__preorder">{preorderLabel}</p>}
            <div className="cart-item__details">
              <div className="cart-item__price">{currency.formatMoney(itemPrice, window.theme.moneyFormat)}</div>
            </div>
            {item.quantity < this.state.minQuantity && (
              <div className="cart-item__message">
                {window.theme.strings.minMax.minimumMessage.replace('{{ quantity }}', this.state.minQuantity)}
              </div>
            )}
            {item.quantity === this.state.maxQuantity && (
              <div className="cart-item__message">
                {window.theme.strings.minMax.maximumMessage.replace('{{ quantity }}', this.state.maxQuantity)}
              </div>
            )}
            <button className="cart-item__remove" onClick={() => this.handleChange(itemKeys, 0)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
                  <path d="M4 4l12 12M16 4L4 16" />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </li>
    );
  }
}

CartBundleItem.propTypes = {
  item: PropTypes.object,
  cartItems: PropTypes.array,
  updateCart: PropTypes.func,
  removeUpsell: PropTypes.func,
  minMax: PropTypes.array,
};

export default CartBundleItem;
